import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { useMobileAppName } from '../../hooks/use-mobile-app-name'
import { selectActiveBuilding } from '../../reducers/buildingSelectorReducer'
import { selectUserData } from '../../reducers/userDataReducer'
import DownloadApp from '../Auth/DownloadApp'
import Dashboard from '../Dashboard'

export const AppDownloadPage = () => {
  const { t } = useTranslation(['app-download-page'])
  const selectedBuilding = useSelector(selectActiveBuilding)
  const userData = useSelector(selectUserData)
  const appName = useMobileAppName()

  const googleStoreLink = selectedBuilding?.googlePlayLink || userData?.buildingId?.googlePlayLink
  const appleStoreLink = selectedBuilding?.iosAppStoreLink || userData?.buildingId?.iosAppStoreLink

  return (
    <Dashboard.Container className="app-download-page">
      <DownloadApp
        content={t('app-download-page:content')}
        customConfig={{
          appleStoreLink,
          googleStoreLink,
          headerAppName: appName,
          headerLogoImageSrc: '/images/logo/elevateos-logo-square-white.png',
        }}
      />
    </Dashboard.Container>
  )
}
